module.exports = __webpack_public_path__ + "static/media/DinningArea-b.b4b88aa7.webp";